import * as React from 'react';
/**
 *
 * Original name: folder
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1247
 *
 */
export const FolderFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m10.463 7-.378-.756A2.237 2.237 0 0 0 8.073 5H3.5v11.75A2.25 2.25 0 0 0 5.75 19h12A2.249 2.249 0 0 0 20 16.75V7h-9.537Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
